// Func = limiting Scope for this file
var lastScrollTop = 0;

function getRooms( roomModule, tag = 'ALL' ){
	let formData = new FormData();
	formData.append("operation", "getRoomsByTag");
	formData.append("tag", tag);

	fetch(`${site_url}ajax/functions.php`, { method: "POST", body: formData,})
		.then((response) => response.json())
		.catch((error) => console.error("Error:", error))
		.then((response) => {
			roomModule.querySelector('.js_rooms_inner').innerHTML = response.html;

			const roomsImagesModuleClass = '.eachRoom_images';
			const roomsImagesModuleSettings = {
				effect: "fade",
				speed: 900,
				slidesPerView: 1,
				loop: true,
				allowTouchMove: false,
				autoplay: false,
				pagination: {
					enabled: false,
				},
				navigation: {
					prevEl: '.eachRoom_images_prev_arrow',
					nextEl: '.eachRoom_images_next_arrow'
				}
			};
	
			buildSwiper(roomsImagesModuleClass, roomsImagesModuleSettings);
		

			roomModule.querySelectorAll('.animate-fade').forEach((target) => {
				observer.observe(target);
			});
			if(document.querySelectorAll('.btn-blue').length > 0){
				document.querySelectorAll('.btn-blue').forEach( btn => {
					if(btn.querySelector('span') === undefined){
						let innerText = btn.innerHTML;
						btn.innerHTML = `<span>${innerText}</span>`;
					}
					if(window.innerWidth > 900){
						btn.addEventListener('mouseenter', function(){
							let img = document.createElement('img');
							img.src = site_url + 'assets/gif/beaufort-btn-blue2.gif?p' + new Date().getTime();
							img.onload = function () {
								btn.setAttribute('style',`background-image:url(${img.src})`)
							}
						})
						btn.addEventListener('mouseleave', function(){
							btn.setAttribute('style',`background-image:none`)
						})
					}
				});
			}
		});

}

function roomsShortcodeFunction(){
	let allShortcodes = document.querySelectorAll(`.rooms.ShortcodeModule`);
	allShortcodes.forEach( roomModule => {
		if( roomModule.querySelector('.rooms_filter') ){
			let filter = roomModule.querySelector('.rooms_filter');
			let beforeNodeClicked = null;
			filter.addEventListener('click', (e) => {
				if( beforeNodeClicked ){
					beforeNodeClicked.classList.remove('active')
				}
				e.target.classList.add('active');
				getRooms(roomModule, e.target.dataset.filter);
				beforeNodeClicked = e.target;

				if( roomModule.querySelector('.rooms_filter-label') ){
					filter.classList.add('folded');
					roomModule.querySelector('.rooms_filter-label').textContent = e.target.textContent
				}
			});

			/* DropDown On Mobile */
			if( roomModule.querySelector('.rooms_filter-label') ){
				roomModule.querySelector('.rooms_filter-label').addEventListener('click', () => {
					roomModule.querySelector('.rooms_filter').classList.toggle('folded');
				})
			}
		}

		if( roomModule.querySelector('.rooms_filter .rooms_filter-item') ){
			roomModule.querySelector('.rooms_filter .rooms_filter-item').click();
		}else{
			getRooms(roomModule);
		}
	} );
}

function getPressItems( pressModule, blogId, tag ){
	let formData = new FormData();
	formData.append("operation", "getPressByTag");
	formData.append("blogId", blogId);
	formData.append("tag", tag);

	fetch(`${site_url}ajax/functions.php`, { method: "POST", body: formData,})
		.then((response) => response.json())
		.catch((error) => console.error("Error:", error))
		.then((response) => {
			pressModule.querySelector('.js-press_list').innerHTML = response.html;
			pressModule.querySelectorAll('.animate-fade').forEach((target) => {
				observer.observe(target);
			});
		});
}

function pressShortcodeFunction(){
	let allShortcodes = document.querySelectorAll(`.js-pressModule`);

	allShortcodes.forEach( pressModule => {
		let filter = pressModule.querySelector('.js-press_filter');
		if(filter){
			let beforeNodeClicked = null;
			filter.addEventListener( 'click', (e) => {
				if( beforeNodeClicked ){
					beforeNodeClicked.classList.remove('active')
				}
				e.target.classList.add('active');
				getPressItems( pressModule, e.target.dataset.blog_id, e.target.dataset.tag );
				beforeNodeClicked = e.target;
			} )
			
			filter.querySelector('li').click();
		} else {
			console.log(pressModule, pressModule.dataset.blog_id);
			getPressItems( pressModule, pressModule.dataset.blog_id, null );
		}
	} );
}

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function burguerMenu(){
	let openButtonMenu = document.querySelector('.navMobile_menuBurger'),
		closeButtonMenu = document.querySelector('.mainNav .close-menu'),
		mainMenu = document.querySelector('aside.mainNav');

	openButtonMenu.addEventListener( 'click', () => {
		mainMenu.classList.add('menuOpen');
		document.querySelector('body').style.overflow = 'hidden';
	} );

	closeButtonMenu.addEventListener( 'click', () => {
		mainMenu.classList.remove('menuOpen');
		document.querySelector('body').removeAttribute('style');
	} );
}

function submenuToShow(containerAllLinks){
	containerAllLinks = document.querySelector(`${containerAllLinks}`);
	containerAllLinks.querySelectorAll('li').forEach( li => {
		li.addEventListener( 'click', (e) => {
			if( li.querySelector('ul.submenu') && !e.target.parentNode.parentNode.classList.contains('submenu') ){
				e.preventDefault();
				li.querySelector('a').classList.toggle('submenu');
				li.querySelector('ul.submenu').classList.toggle('active');
			}
		} );
	} );
}

function loadOverviewMap(){
	let allShortcodes = document.querySelectorAll(`.js-overview_map`);
	allShortcodes.forEach( map => {
		let allPins = map.querySelectorAll('.js-overview_map-pin');
		let lastPinClicked = null;
		allPins.forEach( pin => {
			pin.addEventListener( 'click', () => {
					if( lastPinClicked ){
						lastPinClicked.classList.remove('active')
					}
					pin.classList.add('active');
					lastPinClicked = pin;

					let data_pin = pin.dataset.id_pin ;
					map.querySelectorAll('.overview_map-copy').forEach( block => {
						if( block.dataset.id_pin == data_pin ){
							block.classList.add('active');
							block.removeAttribute('aria-hidden');
						}else{
							block.classList.remove('active');
							block.setAttribute('aria-hidden', 'true');
						}
					} );
			} );
		} );
	} );
}

function getInteractiveMapContent( overviewMapModule, blog_id, entry_id ){
	let formData = new FormData();
	formData.append("operation", "getInteractiveMapContent");
	formData.append("blogId", blog_id);
	formData.append("entryId", entry_id);

	fetch(`${site_url}ajax/functions.php`, { method: "POST", body: formData,})
		.then((response) => response.json())
		.catch((error) => console.error("Error:", error))
		.then((response) => {
			overviewMapModule.querySelector('.js-interactive_map-copy').innerHTML = response.html;
			overviewMapModule.querySelectorAll('.animate-fade').forEach((target) => {
				observer.observe(target);
			});
		});
}

function loadInteractivewMap(){
	let allShortcodes = document.querySelectorAll(`.js-interactive_map`);
	allShortcodes.forEach( map => {
		let allPins = map.querySelectorAll('.js-interactive_map-pin');
		let lastPinClicked = null;
		allPins.forEach( pin => {
			pin.addEventListener( 'click', () => {
				if( lastPinClicked ){
					lastPinClicked.classList.remove('active')
				}
				pin.classList.add('active');
				lastPinClicked = pin;

				getInteractiveMapContent( map, pin.dataset.blog_id, pin.dataset.id_pin );
			} );
		} );

		allPins[0].click();
	} );
}

function dropDownFunctionMobile(){
	let subMenuLabel = document.querySelector(`span.sub-menu-label`);
	let subMenuContainer = document.querySelector(`nav.sub-menu`);
	let itemSubMenuActive = subMenuContainer.querySelector('li a.active');

	subMenuLabel.textContent = itemSubMenuActive.textContent.toUpperCase();

	subMenuLabel.addEventListener( 'click', () => {
		subMenuContainer.classList.toggle('unfolded');
	} );
}

let options = {
	rootMargin: '0px',
	threshold: 0.20,
}
let observer = new IntersectionObserver(observerElements, options);

function observerElements(entries) {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			entry.target.classList.add('fade-in')
		}
	})
}

function scrollSmothToSection( section ){
	if( !section ) return;

	section.scrollIntoView({ 
		behavior: "smooth", 
		block: "center"
	});
	/*
		* The properties used for the parameter 'block' it's for indicate where the section found should be respect the screen 'start, center, end'
	*/
}

const closeButtonLbx = `<?xml version="1.0" encoding="UTF-8"?><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="41.25" height="41.25" viewBox="0 0 41.25 41.25"><rect x="0" width="41.24" height="41.24" style="fill: #00263a;"/><polygon points="27.75 13.55 26.89 12.78 20.62 19.74 14.36 12.78 13.51 13.55 19.88 20.63 13.51 27.7 14.36 28.47 20.62 21.51 26.89 28.47 27.75 27.7 21.37 20.63 27.75 13.55" style="fill: #fff;"/></svg>`;
const closeButtonLbxFromMenuMobile = `<?xml version="1.0" encoding="UTF-8"?><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="12.42" height="12.42" viewBox="0 0 12.42 12.42"><g id="Close"><path id="Path_218223" data-name="Path 218223" d="M11.68,0l-5.47,5.47L.74,0l-.74.74,5.47,5.47L0,11.68l.74.74,5.47-5.47,5.47,5.47.74-.74-5.47-5.47L12.42.74l-.74-.74Z" style="fill: #002a10;"/></g></svg>`
const nextButtonLbx = `<?xml version="1.0" encoding="UTF-8"?><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55"><rect width="55" height="55" style="fill: #00263a;"/><g id="Next"><g id="Path"><path d="M17.05,27v.83h20.41c-.02-.27-.02-.55,0-.82-2.01-.02-11.69-.02-20.41-.01Z" style="fill: #fff;"/></g><g id="Line_14164" data-name="Line 14164"><rect x="26.81" y="31.58" width="12.92" height=".96" transform="translate(-12.82 35.34) rotate(-48.01)" style="fill: #fff;"/></g><g id="Line_14165" data-name="Line 14165"><rect x="32.79" y="16.47" width=".96" height="12.92" transform="translate(-6.8 28.14) rotate(-41.99)" style="fill: #fff;"/></g></g></svg>`
const prevButtonLbx = `<?xml version="1.0" encoding="UTF-8"?><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55" style="rotate:180deg"><rect width="55" height="55" style="fill: #00263a;"/><g id="Next"><g id="Path"><path d="M17.05,27v.83h20.41c-.02-.27-.02-.55,0-.82-2.01-.02-11.69-.02-20.41-.01Z" style="fill: #fff;"/></g><g id="Line_14164" data-name="Line 14164"><rect x="26.81" y="31.58" width="12.92" height=".96" transform="translate(-12.82 35.34) rotate(-48.01)" style="fill: #fff;"/></g><g id="Line_14165" data-name="Line 14165"><rect x="32.79" y="16.47" width=".96" height="12.92" transform="translate(-6.8 28.14) rotate(-41.99)" style="fill: #fff;"/></g></g></svg>`

const customLightbox = new LBX('.js-migue-box', {
	customClass: 'normal-lbx',
	icons: { 
		close: closeButtonLbxFromMenuMobile,
		next: nextButtonLbx,
		prev: prevButtonLbx
	}
});

const customLightboxFull = new LBX('.js-migue-box-full', {
	fullScreen: true,
	customClass: 'full-screen-lbx',
	icons: { 
		close: closeButtonLbx,
		next: nextButtonLbx,
		prev: prevButtonLbx
	}
});

LBX.ICONS.close = closeButtonLbx;
LBX.ICONS.next = nextButtonLbx;
LBX.ICONS.prev = prevButtonLbx;

(function(){

	if(document.querySelectorAll('.btn').length > 0){
		document.querySelectorAll('.btn').forEach( btn => {
			
			if(btn.querySelector('span') === null){
				let innerText = btn.innerHTML;
				btn.innerHTML = `<span>${innerText}</span>`;
			}
			if(window.innerWidth > 900){
				btn.addEventListener('mouseenter', function(){
					let img = document.createElement('img');
					img.src = site_url + 'assets/gif/beaufort-btn2.gif?p' + new Date().getTime();
					img.onload = function () {
						btn.setAttribute('style',`background-image:url(${img.src})`)
					}
				})
				btn.addEventListener('mouseleave', function(){
					btn.setAttribute('style',`background-image:none`)
				})
			}
			
		});
	}
	if(document.querySelectorAll('.btn-blue').length > 0){
		document.querySelectorAll('.btn-blue').forEach( btn => {
			if(btn.querySelector('span') === null){
				let innerText = btn.innerHTML;
				btn.innerHTML = `<span>${innerText}</span>`;
			}
			if(window.innerWidth > 900){
				btn.addEventListener('mouseenter', function(){
					let img = document.createElement('img');
					img.src = site_url + 'assets/gif/beaufort-btn-blue2.gif?p' + new Date().getTime();
					img.onload = function () {
						btn.setAttribute('style',`background-image:url(${img.src})`)
					}
				})
				btn.addEventListener('mouseleave', function(){
					btn.setAttribute('style',`background-image:none`)
				})
			}
			
		});
	}

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseover',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('open');
			});
			itemMenu.addEventListener('mouseout',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('open');
			})
		}
	})

	let allAnchorsWithHash = document.querySelectorAll('a[href^="#"]:not([data-lbx]):not([data-lbx-full]):not(.js-migue-box):not(.js-migue-box-full):not([data-expand])');
	allAnchorsWithHash.forEach( anchor => {
		anchor.addEventListener( 'click', event => {
			event.preventDefault();
			console.log('trying to scroll...');
			let sectionId = anchor.hash.substring(1);
			let sectionFromUrl = document.getElementById(sectionId);
			scrollSmothToSection(sectionFromUrl);
		} )
	} );

	let anchorTotoggleExpand = document.querySelectorAll(`a[data-expand]`);
	anchorTotoggleExpand.forEach( anchor => {
		anchor.addEventListener( 'click', event => {
			event.preventDefault();
			console.log('Trying to toggle expand...');
			let sectionId = anchor.hash.substring(1);
			let sectionFromUrl = document.getElementById(sectionId);
			let containerHeight = 0;
			Array.from(sectionFromUrl.children).forEach(child => { if(child.offsetHeight) {containerHeight = containerHeight + child.offsetHeight} })
		

			if( !sectionFromUrl.classList.contains('expanded') ){
				sectionFromUrl.classList.add('expanded');
				sectionFromUrl.setAttribute('style', `max-height: ${containerHeight}px`);
			}else{
				sectionFromUrl.classList.remove('expanded');
				sectionFromUrl.removeAttribute('style')
			}

			
		})
	} );
	if(document.querySelectorAll('.hidden-form_close').length > 0){
		document.querySelectorAll('.hidden-form_close').forEach( close => {
			close.addEventListener('click', function(e){
				e.preventDefault();
				document.querySelector(close.getAttribute('href')).classList.remove('expanded')
				document.querySelector(close.getAttribute('href')).removeAttribute('style')
			})
		});
	}

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	window.addEventListener("load", (event) => {
		let sectionId = location.hash.substring(1);
		let sectionFromUrl = document.getElementById(sectionId);
		scrollSmothToSection(sectionFromUrl);
	});

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	if( document.querySelector('.rooms.ShortcodeModule') ){
		roomsShortcodeFunction();
	}

	if( document.querySelector('.js-pressModule') ){
		pressShortcodeFunction();
	}

	if( document.querySelector('aside.mainNav') ){
		burguerMenu();
		submenuToShow('.mainNav-inner .inner');
	}
	
	if( document.querySelector('.js-overview_map') ){
		loadOverviewMap();
	}

	if( document.querySelector('.js-interactive_map') ){
		loadInteractivewMap();
	}

	if( document.querySelector(`#default .sub-menu-label`) && document.querySelector(`#default .sub-menu`) ){
		dropDownFunctionMobile();
	}

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

const countDown = function (elements) {

	for (const element of elements) {

		const date = element.dataset.date;
		let formats = element.dataset.formats;

		if (!date || !formats)
			return;
		
		formats = formats.split(',');
		const format = formats.map(format => `<div class="countdown-time"><span></span>${format}</div>`).join('');
		element.insertAdjacentHTML("beforeend", format);
	
		const countDownDate = new Date(date).getTime();
		
		const timer = () => {
			let now = new Date().getTime();
			let dateDiff = countDownDate - now;
	
			let time = {
				days: String(Math.floor(dateDiff / (1000 * 60 * 60 * 24))).padStart(2, '0'),
				hours: String(Math.floor((dateDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0'),
				minutes: String(Math.floor((dateDiff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0'),
				seconds: String(Math.floor((dateDiff % (1000 * 60)) / 1000)).padStart(2, '0')
			}

			time = Object.values(time);

			for (let i = 0; i < formats.length; i++) {
				element.getElementsByTagName("div")[i].getElementsByTagName("span")[0].textContent = time[i];
			}
	
			if (dateDiff < 0)
				clearInterval(timerInterval);
		}
	
		timer();
	
		const timerInterval = setInterval(timer, 1000);
	}

}
document.getElementsByClassName("js-countdown") && countDown(document.getElementsByClassName("js-countdown"));